module.exports = __webpack_public_path__ + "static/media/logo-compact.2d8e101e.svg";